import DialogGuide from '@/global/guides/Dialog'
import { useCompensacaoManualOutletContext } from '@/pages/CompensacaoManual'
import { compensacaoManual } from '@/service/api/endpoints/compensacao-manual'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'

function ExcluirCompensacaoManual() {
    const { id } = useParams()
    const navigate = useNavigate()

    const { isLoading, mutate } = compensacaoManual.mutations.useDelete({
        invalidateQuery: true,
    })

    const data = useCompensacaoManualOutletContext().data.get(Number(id))

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Compensação manual removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover compensação manual')
                }
            },
        })
    }

    return (
        <DialogGuide.Root
            height="auto"
            width="30rem"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <DialogGuide.Content>
                Você tem certeza que deseja excluir esta compensação manual?
                {data && (
                    <div className="mt-4 space-y-2">
                        <p>
                            <strong>Tipo:</strong>{' '}
                            {data.tipo === 'COMPENSAR'
                                ? 'Compensar'
                                : 'Compensado'}
                        </p>
                        <p>
                            <strong>Data:</strong>{' '}
                            {dayjs(data.data).format('DD/MM/YYYY')}
                        </p>
                        <p>
                            <strong>Competência:</strong> {data.competencia}
                        </p>
                        {data.Destinos && data.Destinos.length > 0 && (
                            <p>
                                <strong>Destinos:</strong>{' '}
                                {data.Destinos.length} dia(s)
                            </p>
                        )}
                    </div>
                )}
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Cancelar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton color="error">
                    Excluir
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

export default ExcluirCompensacaoManual
